import { Outlet } from "react-router-dom";
import { Header } from "./Header";
import { Sidebar } from "./Sidebar";

export const MainLayout = () => {
  return (
    <div className="bg-[#F9FAFB] drawer lg:drawer-open">
      <input id="my-drawer" type="checkbox" className="drawer-toggle" />
      <div className="drawer-content flex flex-col min-h-screen">
        <Header />
        <main className="p-5">
          <div className="bg-[#F9FAFB] rounded-xl min-h-[calc(100vh-theme(spacing.32))]">
            <Outlet />
          </div>
        </main>
      </div>
      <Sidebar />
    </div>
  );
}; 